import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperBlogWithResize() {
  withResize(() => createSwiper('is--blog'));
}
